<template>
  <!-- <h2>楓之谷R儲值流程</h2> -->
  <div class="infoCenter tcCss">
    <h3>遊戲登錄/註冊</h3>
    <p>
      登錄/註冊頁面。目前遊戲一共支持5種註冊/登錄方式，包括快速註冊，Facebook登錄，手機號登錄，Google帳號登錄，以及郵箱登錄。
    </p>
    <img src="./../../../assets/info/tc/1.png" />

    <h3>儲值中心</h3>
    <p>
      PC端進入遊戲後，提升角色等級至21級即可解鎖【儲值功能】，選擇左上方【展開】按鈕，選擇【特惠】，即可進入禮包購買頁面
    </p>
    <img src="./../../../assets/info/tc/2.png" />

    <p>1.點擊想要購買的禮包後會跳轉至儲值中心，進入購買禮包的環節</p>
    <p>2.接下來需要確定下列選項</p>
    <p>首先右上角需要選擇語言</p>
    <p>選擇需要充值角色的區服</p>
    <p>選擇遊戲角色</p>
    <p>選擇付款的國家/地區</p>
    <p>選擇對應的支付方式</p>
    <img src="./../../../assets/info/tc/3.png" />

    <p>
      3.選擇充值方式後，手動選擇對應彩鉆檔位，在彈窗位置重復確認角色信息，
      確認無誤後點擊確認付款。*（成功充值後需要在淩晨5點前到遊戲領取，否則可能出現道具丟失。）
    </p>
    <p>PayerMax-PayNow</p>
    <p>點擊PayerMax-PayNow支付渠道，選擇心儀的禮包</p>
    <img src="./../../../assets/info/tc/4.png" />

    <p>4. 確認信息無誤後跳轉至對應支付渠道，根據提示完成支付即可完成購買</p>
    <img src="./../../../assets/info/tc/5.png" />
    <p>TikiPay-Union pay</p>
    <p>點擊TikiPay-Union pay支付渠道，選擇心儀的禮包</p>

    <img src="./../../../assets/info/tc/6.png" />

    <p>
      確認信息無誤後跳轉至直接借記付款界面，正確填寫郵箱地址，手機號碼及姓名，點擊購買
    </p>
    <img src="./../../../assets/info/tc/7.png" />

    <h3>更多頁面功能</h3>
    <p>1.下載</p>
    <p>
      玩家點擊【安裝】，遊戲頁面會在獨立窗口打開，同時可以固定到桌面的任務欄，點擊即可快速進入遊戲，同時也可以在【開始】界面找到啟動icon
    </p>
    <img src="./../../../assets/info/tc/8.png" />
    <p>2.官網</p>
    <p>點擊【官網】，跳轉至官網頁面查看最新最全的遊戲信息！</p>
    <img src="./../../../assets/info/tc/9.png" />
    <img src="./../../../assets/info/tc/10.png" />
    <p>3.收藏</p>
    <p>
      點擊【收藏】後，頁面會添加至瀏覽器的收藏夾，打開瀏覽器後可直接在收藏夾打開遊戲！
    </p>
    <img src="./../../../assets/info/tc/11.png" />
    <p>4.客服</p>
    <p>
      點擊【客服】按鈕，進入客服中心，可查看快捷FAQ問題查找解決方案，如果快捷問題沒有解答你的疑問，可以根據實際問題填寫提問單
    </p>
    <img src="./../../../assets/info/tc/12.png" />
  </div>
</template>

<script>
export default {
  name: "RastarTc",
  data() {
    return {};
  },
  created() {},
};
</script>

<style lang="scss" src="./style.scss" scoped></style>